// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// Get URL from environment variables or fallback to hardcoded value
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  process.env.VITE_SUPABASE_URL ||
  "";

// Get key from environment variables or fallback to hardcoded value
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY ||
  "";

// Export service role key for edge functions
export const SUPABASE_SERVICE_ROLE_KEY = import.meta.env
  .VITE_SUPABASE_SERVICE_ROLE_KEY as string;

// Validate essential environment variables
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  const message =
    "Missing Supabase URL or Anon Key. Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your .env file";
  if (import.meta.env.PROD) {
    throw new Error(message);
  }
  console.error(message);
}

// Create the standard Supabase client
const baseClient = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      storageKey: "hriatnaeng-auth",
      autoRefreshToken: true,
      storage: {
        getItem: (key) => {
          try {
            const storedSession = localStorage.getItem(key);
            return storedSession;
          } catch (error) {
            console.error(
              "Error getting auth session from localStorage:",
              error
            );
            return null;
          }
        },
        setItem: (key, value) => {
          try {
            localStorage.setItem(key, value);
          } catch (error) {
            console.error("Error setting auth session to localStorage:", error);
          }
        },
        removeItem: (key) => {
          try {
            localStorage.removeItem(key);
          } catch (error) {
            console.error(
              "Error removing auth session from localStorage:",
              error
            );
          }
        },
      },
    },
  }
);

// Add helper methods to the client instance
const supabase = Object.assign(baseClient, {
  getUrl: () => SUPABASE_URL,
  getAuthKey: () => SUPABASE_PUBLISHABLE_KEY,
});

// Log the current URL for debugging (only in development)
if (import.meta.env.DEV) {
  console.log("Application origin:", window.location.origin);
}

// Helper function to generate redirect URLs for auth flows
export const getRedirectUrl = (path: string) => {
  const origin = window.location.origin;
  const fullUrl = `${origin}${path}`;
  if (import.meta.env.DEV) {
    console.log("Generated redirect URL:", fullUrl);
  }
  return fullUrl;
};

// Helper function to generate invitation URLs that work correctly
export const getInvitationRedirectUrl = () => {
  const origin = window.location.origin;
  // Use the admin/reset-password route which has our password setup form
  return `${origin}/admin/reset-password`;
};

export { supabase };
